import Etablissement from '@/generated/classes/Etablissement';
import { maskTransform } from "v-mask-directive-filter";
import { typePicto } from "@/framework/base/helpers/Picto";
import { PictoTypes } from "@/generated/classes/Module";

export default class EtablissementExtend  extends Etablissement {
  
  constructor() {
    super();
  }

  public static getTitle (etablissement: Etablissement): string {
    return etablissement.alias != '' ? etablissement.alias : etablissement.nom;
  }

  public static getSubtitle (etablissement: Etablissement): string {
    return maskTransform(etablissement.siret, 'NNN NNN NNN NNNNN');;
  }

  public static getInfo (etablissement: Etablissement): string {
    return etablissement.ville;
  }

  public static getData (etablissement: Etablissement): string[] {
    const res: string[] = [];
    res.push(EtablissementExtend.getTitle(etablissement));
    res.push(EtablissementExtend.getSubtitle(etablissement));
    res.push(EtablissementExtend.getInfo(etablissement));
    return res;
  }

  // eslint-disable-next-line
  public static getPicto (etablissement: Etablissement): string {
    return 'foo';
  }

  // eslint-disable-next-line
  public static getPictoType (etablissement: Etablissement): string {
    return typePicto(PictoTypes.INITIAL);
  }
}
